import { render, staticRenderFns } from "./GroupItem.vue?vue&type=template&id=9f8f2d0a&scoped=true&"
import script from "./GroupItem.vue?vue&type=script&lang=js&"
export * from "./GroupItem.vue?vue&type=script&lang=js&"
import style0 from "./GroupItem.vue?vue&type=style&index=0&id=9f8f2d0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f8f2d0a",
  null
  
)

component.options.__file = "GroupItem.vue"
export default component.exports